webpackJsonp([103555066157098],{

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = PostListing;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(43);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PostListing(_ref) {
	  var title = _ref.title,
	      postEdges = _ref.postEdges;
	
	  var posts = postEdges.map(function (_ref2) {
	    var node = _ref2.node;
	    return {
	      path: '/entry/' + node.frontmatter.path,
	      tags: node.frontmatter.tags,
	      // cover: node.frontmatter.cover,
	      title: node.frontmatter.title,
	      date: node.frontmatter.date,
	      excerpt: node.excerpt,
	      timeToRead: node.timeToRead
	    };
	  });
	
	  return _react2.default.createElement(
	    'section',
	    null,
	    _react2.default.createElement(
	      'h2',
	      null,
	      title
	    ),
	    _react2.default.createElement(
	      'ul',
	      { className: 'categories' },
	      posts.map(function (post) {
	        return _react2.default.createElement(
	          'li',
	          { key: post.title },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: post.path },
	            post.title
	          )
	        );
	      })
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 35:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  // blogPostDir: "sample-posts", // The name of directory that contains your posts.
	  siteTitle: 'Hatch tech blog', // Site title.
	  siteTitleAlt: 'Tech blog about programming', // Alternative site title for SEO.
	  siteLogo: 'https://cdn1.www.st-hatena.com/users/ha/hachibeechan/profile.gif', // Logo used for SEO and manifest.
	  siteUrl: 'https://hachibeedi.github.io/', // Domain of your website without pathPrefix.
	  pathPrefix: '/', // Prefixes all links. For cases when deployed to example.github.io/gatsby-advanced-starter/.
	  siteDescription: 'A GatsbyJS stater with Advanced design in mind.', // Website description used for RSS feeds/meta description tag.
	  siteRss: '/rss.xml', // Path to the RSS file.
	  siteFBAppID: '', // FB Application ID for using app insights
	  disqusShortname: '', // Disqus shortname.
	  postDefaultCategoryID: 'Tech', // Default category for posts.
	  userName: 'Ogura Daiki', // Username to display in the author segment.
	  userTwitter: 'https://twitter.com/hatchinee', // Optionally renders "Follow Me" in the UserInfo segment.
	  userLocation: 'Tokyo', // User location to display in the author segment.
	  userAvatar: 'https://ja.gravatar.com/userimage/41771054/43d236d88acc75effc5d65af6bef4fe5.jpg?size=200', // User avatar to display in the author segment.
	  userDescription: "Yeah, I like animals better than people sometimes... Especially dogs. Dogs are the best. Every time you come home, they act like they haven't seen you in a year. And the good thing about dogs... is they got different dogs for different people.", // User description to display in the author segment.
	  // Links to social profiles/projects you want to display in the author segment/navigation bar.
	  userLinks: [{
	    label: 'GitHub',
	    url: 'https://github.com/hachibeeDI',
	    iconClassName: 'fa fa-github'
	  }, {
	    label: 'Twitter',
	    url: 'https://twitter.com/hatchinee',
	    iconClassName: 'fa fa-twitter'
	  }, {
	    label: 'Email',
	    url: 'mailto:8hachibee125@gmail.com',
	    iconClassName: 'fa fa-envelope'
	  }],
	  copyright: 'Copyright © 2017. Ogura Daiki' // Copyright string for the footer of the website and RSS feed.
	  // themeColor: "#c62828", // Used for setting manifest and progress theme colors.
	  // backgroundColor: "#e0e0e0" // Used for setting manifest background color.
	};

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(49);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _postListing = __webpack_require__(84);
	
	var _postListing2 = _interopRequireDefault(_postListing);
	
	var _siteConfig = __webpack_require__(35);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TagTemplate = function (_React$Component) {
	  _inherits(TagTemplate, _React$Component);
	
	  function TagTemplate() {
	    _classCallCheck(this, TagTemplate);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  TagTemplate.prototype.render = function render() {
	    var tag = this.props.pathContext.tag;
	
	    var postEdges = this.props.data.allMarkdownRemark.edges;
	    var title = 'Posts contain a tag "' + tag + '"';
	    return _react2.default.createElement(
	      'section',
	      { className: 'tag-container' },
	      _react2.default.createElement(_reactHelmet2.default, { title: title + ' | ' + _siteConfig2.default.siteTitle }),
	      _react2.default.createElement(_postListing2.default, { title: title, postEdges: postEdges })
	    );
	  };
	
	  return TagTemplate;
	}(_react2.default.Component);
	
	/* eslint no-undef: "off"*/
	
	
	exports.default = TagTemplate;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-tags-jsx-fe72708d2817c16fd57e.js